module.exports = __webpack_public_path__ + "img/tab-hall-inactive.0c15a786.png";